import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./FooterStyle.css";
import logo from "../assets/images/mahmoudosman-logo.png";
import { useAuthContext } from "../hooks/useAuthContext";

export const Footer = () => {
  const { user } = useAuthContext();
  const [showFullNumber, setShowFullNumber] = useState(false);
  const fullNumber = "(651) 444-0402";
  const maskedNumber = "(651) ***-****";

  const handleClick = () => {
    setShowFullNumber(!showFullNumber);
  };

  return (
    <footer className="footer bg-dark text-white">
      {/* Top Section - Social Media */}
      <div className="footer-top py-4 border-0">
        <div className="container">
          <div className="row align-items-center ">
            <div className="col-md-6 mb-3 mb-md-0">
              <h6 className="mb-0">Connect with me on social media</h6>
            </div>
            <div className="col-md-6 text-md-end">
              <div className="social-links">
                <Link
                  to="https://www.facebook.com/moudeyahmad"
                  className="text-white me-3"
                  aria-label="Facebook"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-facebook-f fa-lg" />
                </Link>
                <Link
                  to="https://www.linkedin.com/in/mahmoudaosman/"
                  className="text-white me-3"
                  aria-label="LinkedIn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-linkedin fa-lg" />
                </Link>
                <Link
                  to="https://github.com/MahmoudAhmadOsman"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white me-3"
                  aria-label="GitHub"
                >
                  <i className="fa fa-github fa-lg" />
                </Link>
                <Link to="#" className="text-white" aria-label="Twitter">
                  <i className="fa fa-twitter fa-lg" />
                </Link>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Middle Section - Main Content */}
      <div className="footer-middle py-5 ">
        <div className="container">
          <div className="row g-4">
            {/* About Column */}
            <div className="col-lg-4 mb-4 mb-lg-0">
              <div className="footer-about">
                <img
                  src={logo}
                  alt="Mahmoud Osman Logo"
                  className="footer-logo mb-3"
                />
                <p className="footer-text">
                  Full Stack Software Engineer specializing in building robust,
                  scalable, and efficient web applications with modern
                  technologies.
                </p>
              </div>
            </div>

            {/* Services Column */}
            <div className="col-sm-6 col-md-4 col-lg-2 mb-4 mb-sm-0">
              <div className="footer-links">
                <h5 className="footer-title">Services</h5>
                <ul className="list-unstyled">
                  <li>
                    <Link to="#" className="footer-link">
                      <i className="fa fa-chevron-right me-2"></i>
                      Database Design
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="footer-link">
                      <i className="fa fa-chevron-right me-2"></i>
                      Web Development
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="footer-link">
                      <i className="fa fa-chevron-right me-2"></i>
                      API Integration
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="footer-link">
                      <i className="fa fa-chevron-right me-2"></i>
                      Cloud Solutions
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Quick Links Column */}
            <div className="col-sm-6 col-md-4 col-lg-2 mb-4 mb-sm-0">
              <div className="footer-links">
                <h5 className="footer-title">Quick Links</h5>
                <ul className="list-unstyled">
                  <li>
                    <Link to="/api/users/register" className="footer-link">
                      <i className="fa fa-chevron-right me-2"></i>
                      Register
                    </Link>
                  </li>
                  <li>
                    <Link to="/api/users/login" className="footer-link">
                      <i className="fa fa-chevron-right me-2"></i>
                      Login
                    </Link>
                  </li>
                  <li>
                    <Link to="/api/courses" className="footer-link">
                      <i className="fa fa-chevron-right me-2"></i>
                      Courses
                    </Link>
                  </li>
                  {/* {user && (
                    <li>
                      <Link to="/api/help-faq" className="footer-link">
                        <i className="fa fa-chevron-right me-2"></i>
                        Help Center
                      </Link>
                    </li>
                  )} */}
                  <li>
                    <Link to="/api/blogs" className="footer-link">
                      <i className="fa fa-chevron-right me-2"></i>
                      Blog
                    </Link>
                  </li>
                  <li>
                    <Link to="/api/about" className="footer-link">
                      <i className="fa fa-chevron-right me-2"></i>
                      About
                    </Link>
                  </li>
                  <li>
                    <Link to="/api/portfolio" className="footer-link">
                      <i className="fa fa-chevron-right me-2"></i>
                      Portfolio
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/api/get-in-touch/contact"
                      className="footer-link"
                    >
                      <i className="fa fa-chevron-right me-2"></i>
                      Contact
                    </Link>
                  </li>{" "}
                  <li>
                    <Link to="/api/jobs/all-jobs" className="footer-link">
                      <i className="fa fa-chevron-right me-2"></i>
                      Careers
                    </Link>
                  </li>
                  {/* /api/get-in-touch/contact */}
                </ul>
              </div>
            </div>

            {/* Contact Column */}
            <div className="col-md-4 col-lg-4">
              <div className="footer-contact">
                <h5 className="footer-title">Contact Info</h5>
                <ul className="list-unstyled">
                  <li className="mb-3">
                    <i className="fa fa-map-marker me-3"></i>
                    <span>St. Paul, MN, USA</span>
                  </li>
                  <li className="mb-3">
                    <i className="fa fa-envelope me-3"></i>
                    <a
                      href="mailto:osman.techy@gmail.com"
                      className="text-decoration-none text-white"
                    >
                      Send me an email
                    </a>
                  </li>
                  <li className="mb-3">
                    <i className="fa fa-phone me-3"></i>
                    <a
                      href="tel:6514440402"
                      className="text-decoration-none text-white"
                      onClick={handleClick}
                    >
                      {showFullNumber ? fullNumber : maskedNumber}
                    </a>
                  </li>

                  <li className="mt-4">
                    <div className="opening-hours">
                      <h6>Working Hours</h6>
                      <p className="mb-0">Mon-Fri: 9AM - 5PM</p>
                      <p className="mb-0">Sat-Sun: Closed</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Section - Copyright */}
      <div className="footer-bottom py-3">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 mb-3 mb-md-0">
              <p className="mb-0">
                &copy; {new Date().getFullYear()} Mahmoud Osman. All rights
                reserved.
              </p>
            </div>
            <div className="col-md-6 text-md-end">
              <div className="footer-legal-links">
                <Link to="/privacy-policy" className="text-white me-3">
                  Privacy Policy & Terms of Service
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
